<template>
  <div>
    <div class="action-lists">
      <el-tabs v-model="activeName" @tab-click="showOther" style="width: 100%;">
        <el-tab-pane label="推广计划" name="plan"></el-tab-pane>
        <el-tab-pane label="推广组" name="group"></el-tab-pane>
        <el-tab-pane label="推广单元" name="adv"></el-tab-pane>
      </el-tabs>
      <div class="table">
        <div class="btns">
          <div class="btns">
            <el-button type="primary" icon="fa fa-plus-circle" @click="add()" size="small" style="margin-right: 20px;"> 新建推广单元</el-button>
            <div class="demo-input-suffix">
              关键词：
              <el-input placeholder="请输入关键词" v-model="keyword" size="small" style="width: 350px;" show-word-limit maxlength="32">
                <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" @select="selectRow" @select-all="selectAll">
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column label="开关" show-overflow-tooltip width="80px">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="adv_title" label="单元名称"></el-table-column>
            <el-table-column prop="price" label="出价"></el-table-column>
            <el-table-column prop="price" label="出价方式">
              <template slot-scope="scope">
                {{ scope.row.type === 1 ? 'CPM' : 'CPC' }}
              </template>
            </el-table-column>
            <el-table-column label="状态" width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.status === false">暂停</span>
                <span style="color: red;" v-else>启动</span>
              </template>
            </el-table-column>
            <el-table-column prop="handle_title" label="审核状态" width="90px"></el-table-column>
            <el-table-column label="预览" width="120">
              <template slot-scope="scope">
                <div><img :src="getImage(scope.row.video_path)" style="width: 100px; height: 60px; margin-right: 5px;"></div>
              </template>
            </el-table-column>
            <el-table-column prop="read" label="曝光"></el-table-column>
            <el-table-column prop="click" label="点击"></el-table-column>
            <el-table-column prop="pay" label="消耗"></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip width="100">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="edit(scope.$index)">编辑</el-button>
                <el-button type="text" size="mini" @click="delOne(scope.row.adv_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page-c">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      font1: '1',
      keyword: '',
      title: '添加创意',
      dialogFormVisible: false,
      editFiles: [],
      dialogImageUrl: '',
      dialogVisible: false,
      tableData: [],
      type: 'add',
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      loading: true,
      ids: [],
      isEdit: true,
      group_name: '',
      activeName: 'adv',
      options: [{
        value: '0',
        label: '暂停'
      }, {
        value: '1',
        label: '启动'
      }],
      status: '' // 状态搜索
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getGroupLists(plan_id) {
      return new Promise((resolve, reject) => {
        try {
          this.$http.post('/trader/index/getGroupForPlanId', {
            plan_id
          }).then(res => {
            resolve(res);
          });
        } catch (e) {
          reject({ code: 500, msg: '未知错误' });
        }
      });
    },
    getData() {
      this.$http.post('/trader/index/getAdvLists', {
        status: this.status,
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    add() {
      this.$emit('jump_form_adv', []);
    },
    edit(index) {
      this.$emit('jump_form_adv', this.tableData[index]);
    },
    selectRow(sel, row) {
      const selected = sel.length && sel.indexOf(row) !== -1;
      if (selected) {
        if (this.ids.indexOf(row.adv_id) === -1) {
          this.ids.push(row.adv_id);
        }
      } else {
        if (this.ids.indexOf(row.adv_id) !== -1) {
          this.ids.splice(this.ids.indexOf(row.adv_id), 1);
        }
      }
    },
    selectAll(sel) {
      if (sel.length > 0) {
        this.ids = [];
        for (var i = 0; i < sel.length; i++) {
          this.ids.push(sel[i].adv_id);
        }
      } else {
        this.ids = [];
      }
    },
    changeStatusOne(index) {
      this.ids.push(this.tableData[index].adv_id);
      this.changeStatus(this.tableData[index].status ? 1 : 0);
    },
    changeStatus(val) {
      if (this.ids.length) {
        this.$http.post('/trader/index/changeAdvStatus', {
          ids: this.ids.join(','),
          value: val
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功，仅审核通过的创意可修改状态');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    delOne(id) {
      this.ids.push(id);
      this.del();
    },
    del() {
      if (this.ids.length) {
        this.$http.post('/trader/index/delAdv', {
          ids: this.ids.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    showOther(type) {
      this.$emit('showOther', this.activeName);
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    }
  },
  watch: {
    'form.plan_id'(newVal, oldVal) {
      this.getGroupLists(newVal).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
          if (this.isEdit) {
            this.form.group_id = '';
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped="">
  .action-lists {
    background: #fff;
    width: calc(100% - 32px);
    padding: 24px 16px;
    .display {
      display: flex;
      align-items: center;
      height: 50px;
    }
    .left-btns {
      .display;
      div {
        width: 140px;
        height: 100%;
        line-height: 50px;
        text-align: center;
        color: #0056AF;
        cursor: pointer;
      }
      .selected {
        color: #166D9F;
        background: #fff;
      }
    }
    .right-action {
      .display;
      div {
        width: 34px;
        height: 34px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .table {
    width: 100%;
    .make {
      padding: 20px 0;
    }
    .btns {
      margin-bottom: 16px;
      color: #606266;
      font-size: 14px;
      .demo-input-suffix {
        display: inline-block;
        margin-right: 16px;
      }
    }
  }
  .page-c {
    background: #fff;
    padding: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
</style>
